import { getOSM } from '../OverworldAnimation.js';
import Boundary from './Boundary.js';

export default class WaterEntryZone extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
        };
    }

    static deserialize(data) {
        return new WaterEntryZone({ position: data.position });
    }

    constructor({ position }) {
        super({ position });
        this.interactionPriority = 8;
    }

    entered() {
        const playerPosition = getOSM().player.position;
        return playerPosition.x === this.position.x && playerPosition.y === this.position.y;
    }
}
